import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ComponentsModule } from '../../components/components.module';
import { PI_MODULES } from '../base/prime-modules';
import { LlamadasComponent } from './reportes/llamadas/llamadas.component';
import { SeguimientoRoutingModule } from './seguimiento-routing.module';
import { GestionCobrosComponent } from './reportes/gestion-cobros/gestion-cobros.component';
import { CobrosRecuperadorComponent } from './reportes/cobros-recuperador/cobros-recuperador.component';
import { TarjetasCreditoActualizadasComponent } from './reportes/tarjetas-credito-actualizadas/tarjetas-credito-actualizadas.component';
import { CarouselModule } from 'primeng/carousel';
import { ToastModule } from 'primeng/toast';
import { ButtonModule } from 'primeng/button';
import { SplitButtonModule } from 'primeng/splitbutton';
import { DialogModule } from 'primeng/dialog';



@NgModule({
  declarations: [
    LlamadasComponent,
    GestionCobrosComponent,
    CobrosRecuperadorComponent,
    TarjetasCreditoActualizadasComponent,
  ],
  imports: [
    CommonModule,
    ComponentsModule,
    SeguimientoRoutingModule,
    CarouselModule,
    ButtonModule,
    ToastModule,
    SplitButtonModule,
    DialogModule,
    ...PI_MODULES
  ]
})
export class SeguimientoModule { }
